import { render } from "./DislikeRecipe.vue?vue&type=template&id=4da6db02&scoped=true"
import script from "./DislikeRecipe.vue?vue&type=script&lang=js"
export * from "./DislikeRecipe.vue?vue&type=script&lang=js"

import "./DislikeRecipe.vue?vue&type=style&index=0&id=4da6db02&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da6db02"]])

export default __exports__